// threejs は @types/three から読み込む
// import * as THREE from 'three';

export default class TopView2D {
  private _width: number = 300;

  private _height: number = 300;

  private _el: HTMLElement = document.createElement('div');

  public canvas: HTMLCanvasElement = document.createElement('canvas');

  private _canvasCtx: CanvasRenderingContext2D;

  public image2d: HTMLImageElement;

  private _mark: HTMLCanvasElement = document.createElement('canvas');

  private _markCtx: CanvasRenderingContext2D;

  public elemnt: HTMLElement = this._el;

  public ofsetX: number = -this._width * 0.5;

  public ofsetY: number = -this._height * 0.5;

  constructor(id: string, right: number, top: number, container: HTMLElement, img: string) {
    console.log('★★★★★TopView2D');
    if (this.canvas.getContext) {
      this._canvasCtx = this.canvas.getContext('2d');
    }
    if (this._mark.getContext) {
      this._markCtx = this._mark.getContext('2d');
    }
    this._el.id = id;
    this._el.style.background = 'rgba(0, 25, 50, 0.3)';
    this._el.style.position = 'fixed';
    this._el.style.padding = '0';
    this._el.style.margin = '0';
    this._el.style.width = `${this._width}px`;
    this._el.style.height = `${this._height}px`;
    this._el.style.opacity = '1';
    this._el.style.zIndex = '1';
    this._el.style.top = `${top}px`;
    this._el.style.right = `${right}px`;
    this._el.style.zIndex = '100';
    this._el.style.transformOrigin = `${this._width * 0.5} ${this._height * 0.5}`;
    container.appendChild(this._el);

    this.canvas.id = 'topView2d';
    this.canvas.style.position = 'fixed';
    this.canvas.width = this._width;
    this.canvas.height = this._height;
    this._el.appendChild(this.canvas);
    this.image2d = new Image();
    this.image2d.src = img;
    this.image2d.crossOrigin = 'Anonymous';
    this.image2d.onload = () => {
      // let ctx = this.canvas.getContext("2d");
      this._canvasCtx.drawImage(this.image2d, 0, 0);
    };
    // マークのキャンバスはメインキャンバスにdrawするためメモリ上に保持するだけ
    this._mark.style.position = 'relative';
    this._mark.style.top = '0';
    this._mark.style.left = '0';
    this._mark.width = this._width;
    this._mark.height = this._height;
    // this._el.appendChild(this._mark);
  }

  /**
   * 2D平面画像の差し替え
   * @param img
   */
  public setImage(img: string): void {
    this.drawTopView();
    this.image2d = new Image();
    this.image2d.src = img;
    this.image2d.crossOrigin = 'Anonymous';
    this.image2d.onload = () => {
      this._canvasCtx.drawImage(this.image2d, 0, 0);
    };
  }

  /**
   * 表示
   */
  public show(): void {
    this._el.style.visibility = 'visible';
  }

  /**
   * 非表示
   */
  public hide(): void {
    this._el.style.visibility = 'hidden';
  }

  /**
   * 平面図の描画 floor = 表示階
   * @param floor
   */
  private drawTopView(): void {
    const ctx = this.canvas.getContext('2d');
    ctx.strokeStyle = 'rgba(255, 255, 255, 1)';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.strokeRect(0, 0, this._width, this._height);
  }

  /**
   * 拡大縮小倍率
   * @param val
   */
  public scale(val: number): void {
    this._el.style.transform = `scale(${val},${val})`;
  }

  public dispose(): void {
    const ctx = this.canvas.getContext('2d');
    ctx.clearRect(0, 0, this._width, this._height);
    this.image2d = null;
  }
}
